import { get, post } from "../../../services/request";

export const dataCenterAutomationSaveBulk = data => post('DocumentMapping/DataCenterAutomationSaveBulk', data);

export const getDataCenterAutomationList = data => post('DataCenterAutomation/GetDataCenterAutomationListByID', data);

export const getDocumentMappingsByAutomationID = data => post('DocumentMapping/GetDocumentMappingsByAutomationID', data);

export const folderPathTestConnection = data => post('DocumentMapping/FolderPathTestConnection', data);

export const exportDocumentMapping = (automationID) => {
    return get(`/DataCenterAutomation/ExportDocumentMapping/${automationID}`);
};
